import Api from '@/api'

import ENUM from '@/assets/ENUM'

import Storage from '@/helpers/storage'

import Auth from '@/modules/auth'
import Loop from '@/modules/loop'
import Firebase from '@/modules/firebase'

import {configuration} from '../../../configuration'

const User = {
    
    async refreshSubscriptions(asyncFetchMeantime, doneFunction) {
    
        return Loop.start(Api.newsletters.get, asyncFetchMeantime, doneFunction)
            .catch(() => {})
    },

    async sortSubscriptions(subscriptions, extras) {
        const cleanSubscriptions = subscriptions
            .filter(item => !item.invalidGrant)
            .sort((itemA, itemB) => Number(!!itemB.notSeen) - Number(!!itemA.notSeen)) //sort in order true and false/undefined

        return subscriptionsAdds(cleanSubscriptions, extras)
    },
    
    getUserAsync() {

        return Api.user.getUser()
            .catch(() => {
                Auth.disconnect()
            })
    },

    async getUserSync() {
        return await Api.user.getUser()
    }
}


export default User

async function subscriptionsAdds(array, extras = []) {
    
    if (!Storage.getItem('usedSharingCard')) {
        const sharingCard = {type: ENUM.NEWSLETTERS.CARDS.SHARING}
        await Firebase.getValue('sharing_cards_positions', 'Object')
            .then(firebaseData => {
                return firebaseData && firebaseData.positions
                    ? addCardWithPosition(array, firebaseData.positions, sharingCard)
                    : addCardWithPosition(array, configuration.sharingCardsPositionDefault, sharingCard)
            })
            .catch(() => {
                return addCardWithPosition(array, configuration.sharingCardsPositionDefault, sharingCard)
            })
        
    }
    
    for (const specialCard of extras) {
        addCardWithPosition(array, [specialCard.position], {...specialCard, type: ENUM.NEWSLETTERS.CARDS.MARKET})
    }
    
    array.forEach(item => item.type = item.type || ENUM.NEWSLETTERS.CARDS.SUBSCRIPTIONS)
    
    return array
    
}

function addCardWithPosition(array, positions, card) {
    positions.forEach(position => {
        if (array.length > position) {
            array.splice(position, 0, card)
        }
    })
    return array
}
